import React from "react";
import { StyledContainerButton } from "./VerificationStatusButton.styled";
import { BodyTyp, CaptionsTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { theme } from "../../constants/StyledComponents";
import { EMPTY_STRING } from "../../constants/Dictionary";

type VerificationStatusButtonProps = {
  label?: string;
  color: string;
  title?: string;
};

export const VerificationStatusButton = ({
  label,
  color,
  title,
}: VerificationStatusButtonProps) => {
  return (
    <>
      <CaptionsTyp color={theme.colors.grey_2}>{title}</CaptionsTyp>
      <StyledContainerButton $bgColor={color}>
        {label ? (
          <BodyTyp variant="3" fontWeight={FontWeightEnum.SEMIBOLD}>
            {label}
          </BodyTyp>
        ) : (
          <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
            {EMPTY_STRING}
          </BodyTyp>
        )}
      </StyledContainerButton>
    </>
  );
};
